import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { GreenleafRouteSummaryReport } from './Pages';

export const GreenleafRouteSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={GreenleafRouteSummaryReport} />
    </Fragment>
)